import React from 'react';
const Metrics: React.FC<{ onBack?: () => void }> = ({ onBack }) => (
  <section className="bg-white py-24 px-6">
    <div className="max-w-4xl mx-auto space-y-6">
      {onBack && <button onClick={onBack} className="underline text-sm">Back to home</button>}
      <h2 className="text-3xl serif font-bold">Public Sector Capacity Building</h2>
      <p className="text-lg text-slate-600 leading-relaxed">LeadBold Resource Consulting Ltd convened a retreat for the Nigerian Senate Committee on Public Procurement, focused on oversight, transparency, accountability, and compliance.</p>
      <a href="https://von.gov.ng/public-procurement-senate-harps-on-strict-compliance-transparency/" target="_blank" rel="noopener noreferrer" className="inline-block underline">Read the Voice of Nigeria report</a>
    </div>
  </section>
);
export default Metrics;
